import CardDisclaimerBase from "components/General/CardDisclaimerBase/CardDisclaimerBase";

export default CardDisclaimerBase;
